import SuccessPopup from '@repo/ui/components/Popups/SuccessPopup';
import { SecondaryButton } from '@repo/ui/components/buttons/SecondaryButton';
import { PrimaryButton } from '@repo/ui/components/buttons/PrimaryButton';
import CancelPopup from '@repo/ui/components/Popups/CancelPopup';

import type { ComponentsModalSubmissionProps } from '../../types/component-props.types';

export default function Submission({
    setShowCancelPopup,
    setShowSuccessPopup,
    showCancelPopup,
    showSuccessPopup,
    loading,
    onClose,
    onAddAnother,
    onSubmit,
    cancelText1 = 'الغاء تسجيل طالب في الدوره',
    cancelText2 = 'أنت على وشك إلغاء عملية تسجيل طالب في الدوره دون إكمال البيانات المطلوبة. سيتم تجاهل جميع البيانات المدخلة، هل أنت متأكد؟',
    cancelButton1 = 'إكمال التسجيل',
    cancelButton2 = 'إلغاء التسجيل',
    successText1 = 'تم إضافه تسجيل طالب في الدوره بنجاح',
    successText2 = 'تم إضافه تسجيل طالب في الدوره بنجاح.',
    successButton1 = 'العودة لقائمة الدورات',
    successButton2 = 'إضافه دوره اخرى',
    reloadOnSuccess = true,
    submitLabel = 'إضافه',
}: ComponentsModalSubmissionProps) {
    const handleAddAnother = () => {
        setShowSuccessPopup(false);
        onAddAnother();
    };

    return (
        <>
            <div className="flex flex-row mt-8 w-full">
                <SecondaryButton
                    type="button"
                    className="w-full xl:py-3 border bordr-[#E8EFF6] xl:font-semibold"
                    onClick={() => setShowCancelPopup(true)}
                >
                    الغاء
                </SecondaryButton>

                <PrimaryButton
                    type="button"
                    className="w-full xl:py-3 xl:font-semibold ms-6"
                    disabled={loading}
                    onClick={onSubmit}
                >
                    {loading ? 'جاري التحميل...' : submitLabel}
                </PrimaryButton>
            </div>

            <CancelPopup
                open={showCancelPopup}
                onClickButton1={() => {
                    setShowCancelPopup(false);
                }}
                onClickButton2={() => {
                    setShowCancelPopup(false);
                    onClose();
                }}
                text1={cancelText1}
                text2={cancelText2}
                textButton1={cancelButton1}
                textButton2={cancelButton2}
            />
            <SuccessPopup
                text1={successText1}
                text2={successText2}
                textButton1={successButton1}
                textButton2={successButton2}
                open={showSuccessPopup}
                onAddAnother={handleAddAnother}
                onReturnToList={() => {
                    setShowSuccessPopup(false);
                    onClose();
                    if (reloadOnSuccess) {
                        window.location.reload();
                    }
                }}
            />
        </>
    );
}
